export default __webpack_public_path__ + "static/media/10t.ac20aad4.jpg";